export default {
  getPackingList: (state) => state.packingList,
};
